// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"QualityControlForm__wrapper__8R5Jb","submitResult":"QualityControlForm__submitResult__3_Xtn","actionWrapper":"QualityControlForm__actionWrapper__1hEJ9","wrapper2faOptions":"QualityControlForm__wrapper2faOptions__JAgjL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QualityControlForm/QualityControlForm.css
// module id = 1248
// module chunks = 0